import script from "./LoginRegisterDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginRegisterDialog.vue?vue&type=script&setup=true&lang=js"

import "./LoginRegisterDialog.vue?vue&type=style&index=0&id=27cff7a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cff7a6"]])

export default __exports__